import React, { Component } from 'react';
import { connect } from 'react-redux';
import { shape, string, object, func } from 'prop-types';
import { renderRoutes } from 'react-router-config';
import { translate } from 'react-i18next';

import { APP_LANGUAGES as APPLICATION_SUPPORTED_LANGUAGES } from '@blueberry/config/site';
import { saveLocale, getLocaleCode } from '@blueberry/redux/locale';

import NotFound from '../NotFound';

/**
 * We have:
 *
 * 1. List of supported languages that client can alter: footer.
 * 2. List of Supported language that client can't alter but application supports.
 */

const mapStateToProps = state => ({
  currentLocale: getLocaleCode(state),
});

class LocaleHandler extends Component {
  componentDidMount = () => {
    window.addEventListener('popstate', this.onBackButtonEvent);
  };

  componentWillUnmount = () => {
    window.removeEventListener('popstate', this.onBackButtonEvent);
  };

  onBackButtonEvent = () => {
    const {
      match: {
        params: {
          locale, // next locale incoming!
        },
      },
      i18n,
      saveLocale,
      currentLocale,
    } = this.props;

    const supportedLanguage = APPLICATION_SUPPORTED_LANGUAGES[locale];

    if (locale && locale !== currentLocale && supportedLanguage) {
      i18n.changeLanguage(supportedLanguage, () => {
        saveLocale({
          language: supportedLanguage,
          localeCode: locale,
          region: locale.slice(-2),
        });
      });
    }
  };

  render() {
    const {
      match: {
        params: { locale },
      },
      route,
    } = this.props;

    return (
      <div>
        {locale && !APPLICATION_SUPPORTED_LANGUAGES[locale] ? (
          <NotFound />
        ) : (
          renderRoutes(route.routes)
        )}
      </div>
    );
  }
}

LocaleHandler.propTypes = {
  currentLocale: string.isRequired,
  i18n: object.isRequired,
  match: shape({
    params: shape({
      locale: string,
    }).isRequired,
  }).isRequired,
  route: object.isRequired,
  saveLocale: func.isRequired,
};

LocaleHandler.defaultProps = {
  match: {},
  params: {},
  locale: '',
};

export default connect(mapStateToProps, { saveLocale })(
  translate()(LocaleHandler)
);



// WEBPACK FOOTER //
// ./app/containers/LocaleHandler/LocaleHandler.jsx